import React from "react";

const WardrobeIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.0099 13.4075L2.4328 25.6001C1.43777 26.5575 2.2736 28.023 3.80594 28.023H26.2139C27.7462 28.023 28.5821 26.5575 27.587 25.6001L15.0099 13.4075Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M14.7712 13.6617C14.9984 12.6831 14.887 11.6581 14.4545 10.7486C14.022 9.83917 13.2932 9.09721 12.3831 8.64003C6.85078 5.57234 12.3831 0.355317 16.2239 2.46558C17.2317 3.03075 17.9696 3.96567 18.2756 5.06485C18.5816 6.16402 18.4306 7.33751 17.8558 8.3274"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M6.9502 20.9497L10.0348 27.769"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
    <path
      d="M22.5322 20.6958L20.0049 28.0231"
      stroke="currentColor"
      strokeWidth="2"
      strokeMiterlimit="10"
    />
  </svg>
);

export default WardrobeIcon;
